import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtWhen } from "@/lib/api";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import ClientsPanel from "@/components/admin/ClientsPanel";
import LicensesPanel from "@/components/admin/LicensesPanel";
import PromosPanel from "@/components/admin/PromosPanel";

const ACTIONS = { license_grant: "Licença liberada", license_codes: "Códigos gerados", license_revoke: "Licença revogada", credits_grant: "Contestações grátis",
  promo_create: "Código promocional criado", promo_toggle: "Código promocional alterado", password_reset_admin: "Senha resetada" };

function AuditPanel() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/audit").then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  return (
    <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white" data-testid="audit-table">
      <table className="w-full min-w-[720px] text-left">
        <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-500"><tr>{["Quando", "Ação", "Cliente", "Detalhes", "Por"].map((h) => <th key={h} className="px-4 py-3">{h}</th>)}</tr></thead>
        <tbody>{items.map((a) => (
          <tr key={a.audit_id} className="border-t border-slate-100 text-sm">
            <td className="px-4 py-3 text-xs text-slate-500">{fmtWhen(a.at)}</td>
            <td className="px-4 py-3 font-semibold">{ACTIONS[a.action] || a.action}</td>
            <td className="px-4 py-3">{a.target_email || "—"}</td>
            <td className="px-4 py-3 text-slate-600">{a.details}</td>
            <td className="px-4 py-3 text-xs text-slate-500">{a.admin_email}</td>
          </tr>
        ))}</tbody>
      </table>
      {!items.length && <p className="p-6 text-center text-sm text-slate-500">Nenhuma ação registrada ainda.</p>}
    </div>
  );
}

const TABS = [["clients", "Clientes", ClientsPanel], ["licenses", "Licenças", LicensesPanel], ["promos", "Códigos promocionais", PromosPanel], ["audit", "Histórico", AuditPanel]];

export default function LicenseCenter() {
  return (
    <Tabs defaultValue="clients" data-testid="license-center">
      <TabsList className="mb-5 h-auto flex-wrap bg-amber-50">
        {TABS.map(([k, v]) => <TabsTrigger key={k} value={k} data-testid={`lc-tab-${k}`} className="px-4 py-2">{v}</TabsTrigger>)}
      </TabsList>
      {TABS.map(([k, , C]) => <TabsContent key={k} value={k}><C /></TabsContent>)}
    </Tabs>
  );
}
